app.factory('treatmentCostSimulationModel', ['$rootScope', 'baseModel', 'treatmentCostSimulationService',
    function($rootScope, baseModel, treatmentCostSimulationService) {

        function TreatmentCostSimulationModel() {

            this.get = function(visitCardId) {
                treatmentCostSimulationService.get(visitCardId).then(
                    function (simulation) {
                        $rootScope.$broadcast(Event.TREATMENT_COST_SIMULATION.GET.SUCCESS, simulation);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.TREATMENT_COST_SIMULATION.GET.ERROR, error);
                    }
                )
            };

            this.suggest = function(visitCardId, simulation) {
                treatmentCostSimulationService.suggest(visitCardId, simulation).then(
                    function (simulation) {
                        $rootScope.$broadcast(Event.TREATMENT_COST_SIMULATION.SUGGEST.SUCCESS, simulation);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.TREATMENT_COST_SIMULATION.SUGGEST.ERROR, error);

                        baseModel.broadcastOperationFailed();
                    }
                )
            };

            this.run = function(simulation) {
                treatmentCostSimulationService.run(simulation).then(
                    function (simulation) {
                        $rootScope.$broadcast(Event.TREATMENT_COST_SIMULATION.RUN.SUCCESS, simulation);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.TREATMENT_COST_SIMULATION.RUN.ERROR, error);

                        $rootScope.$broadcast(Event.NOTIFICATION, new NotificationVO(Enum.NOTIFICATION_TYPE.ERROR, 'T.SYSTEM.NOTIFICATION.NOT_ENOUGH_DATA_TO_PERFORM_SIMULATION'));
                    }
                )
            };

            this.addToDataSet = function(simulation) {
                treatmentCostSimulationService.addToDataSet(simulation).then(
                    function (simulation) {
                        $rootScope.$broadcast(Event.TREATMENT_COST_SIMULATION.ADD_TO_DATA_SET.SUCCESS, simulation);

                        baseModel.broadcastOperationSucceeded();
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.TREATMENT_COST_SIMULATION.ADD_TO_DATA_SET.ERROR, error);

                        baseModel.broadcastOperationFailed();
                    }
                )
            };

        }

        return new TreatmentCostSimulationModel();
    }
]);
